<template lang="pug">
  div
    v-row
      v-col.py-0(cols="12" v-for="(field,ind) in createdFields", :key="'field'+ind")
        .d-flex
          BaseCurrencyInputField(:currencyItems="currencyItems", :value="field" @input="(event)=>{update(ind, event)}")
          v-btn(@click="remove(ind)" icon)
            v-icon(size="24" color="red lighten-1") mdi-close-circle
      v-col.text-center.pt-0(cols="12")
        v-btn(@click="add" icon)
          v-icon(size="24" color="green lighten-1") mdi-plus-circle
</template>

<script>
  export default {
    name: "BaseCurrencyInputDynamicField",
    model: {
      prop: 'value',
      event: 'input'
    },
    props: {
      value: {
        type: Array,
        default: function(){
          return []
        }
      },
      currencyItems: {
        type: Array,
        default: function(){
          return []
        }
      },
      initialValue: {
        type: Object,
        default: null
      },
    },
    data:() => ({
      createdFields: [],
    }),
    watch: {
      value: function(val){
        this.createdFields = val;
      }
    },
    created(){
      this.createdFields = this.value;
    },
    methods:{
      add(){
        if(this.initialValue != null){
          this.createdFields.push({ currency: this.initialValue.currency, quantity: this.initialValue.quantity });
        } else {
          this.createdFields.push({ currency: '', quantity: '' });
        }
        this.updateValue();
      },
      update(ind, event){
        this.createdFields[ind].currency = event.currency;
        this.createdFields[ind].quantity = event.quantity;
        this.updateValue();
      },
      remove(ind){
        this.createdFields.splice(ind, 1);
        this.updateValue();
      },
      updateValue(){
        this.$emit('input', this.createdFields);
        this.$emit('update');
      },
    },
  }
</script>

<style lang="sass">
</style>